// Module
var code = `<label class="fdx-toggle" ng-class="\$ctrl.themeClass"> <input type="checkbox" ng-model="\$ctrl.ngModel" ng-change="\$ctrl.onChangeHandler()"> <span class="slider" ng-class="{ 'smooth-transitions': \$ctrl.useTransitions }"></span> </label>`;
// Exports
module.exports = code;